const ServiceCard = ({ title, items, icon }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-sm p-8 hover:border-summit-gold transition-all duration-300">
      {icon && <div className="text-summit-navy mb-4 text-3xl">{icon}</div>}
      <h3 className="text-xl font-bold text-summit-navy-dark mb-4">{title}</h3>
      <ul className="space-y-2">
        {items.map((item, index) => (
          <li key={index} className="text-summit-grey text-sm flex items-start">
            <span className="text-summit-gold mr-2 mt-1">•</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceCard;